define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var SERVICE_NAME = '$ilmnUiIdleService';

    angular.module(MODULE_NAME)
        .provider(SERVICE_NAME, IlmnIdleServiceProvider);

    function IlmnIdleServiceProvider() {
        var state = {
            disabled: false,
            verbose: true
        };

        return {
            disable: disable,
            verboseLogs: verboseLogs,
            $get: ['$log', '$rootScope', '$cookies', IlmnIdleService]
        };

        function disable(bool) {
            state.disabled = bool === true;
        }

        function verboseLogs(bool) {
            state.verbose = bool === true;
        }

        function IlmnIdleService($log, $rootScope, $cookies) {
            var logoutFn;

            return {
                isDisabled: isDisabled,
                setLogoutFn: setLogoutFn,
                logout: logout,
                log: log
            };

            function isDisabled() {
                return state.disabled;
            }

            function setLogoutFn(fn) {
                if(typeof fn != 'function') {
                    throw TypeError("setLogoutFn expects argument 1 to ge a callable function.");
                }

                logoutFn = fn;
            }

            function logout() {
                $cookies.remove("psToken", {domain: '.illumina.com', path: '/'});
                $cookies.remove("psTokenIssuingAuthorities", {domain: '.illumina.com', path: '/'});
                $rootScope.$broadcast('$ilmnUiIdle.userLogout');

                if(logoutFn) {
                    return logoutFn();
                }
            }

            function log(msg) {
                if(state.verbose) {
                    $log.debug('ilmn-ui-idle: '+msg, new Date().toLocaleTimeString());
                }
            }
        }
    }


    return SERVICE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-idle/scripts/idle.service.js
// module id = 44
// module chunks = 0 1